/* PDP behaviors: sticky tab nav scroll-spy, identifier copy buttons,
   price-break row highlight synced to the qty input, FBT total + add-all.
   Vanilla JS, no libraries. */
/* two sections may emit this same script tag; execute once */
if (!window.__pdpB2B) {
  window.__pdpB2B = true;

(function () {
  'use strict';

  /* ---- scroll-spy tab nav ---- */
  var nav = document.querySelector('[data-tabs-nav]');
  if (nav) {
    var links = Array.from(nav.querySelectorAll('[data-tab-link]'));
    var panels = links
      .map(function (l) { return document.querySelector(l.getAttribute('href')); })
      .filter(Boolean);
    var track = nav.querySelector('[data-nav-track]') || nav.querySelector('ul');
    var setActive = function (id) {
      links.forEach(function (l) {
        var active = l.getAttribute('href') === '#' + id;
        l.classList.toggle('is-active', active);
        /* keep the active tab in view inside the scrolling track */
        if (active && track && track.scrollWidth > track.clientWidth) {
          var lr = l.getBoundingClientRect();
          var tr = track.getBoundingClientRect();
          if (lr.left < tr.left + 24 || lr.right > tr.right - 24) {
            track.scrollTo({ left: l.offsetLeft - track.clientWidth / 2 + l.offsetWidth / 2, behavior: 'smooth' });
          }
        }
      });
    };

    /* ---- overflow handling: scroll (fades + arrows) or More menu ---- */
    var mode = nav.getAttribute('data-nav-overflow') || 'scroll';
    var prevBtn = nav.querySelector('[data-nav-prev]');
    var nextBtn = nav.querySelector('[data-nav-next]');
    function updateNavOverflow() {
      if (!track) return;
      var overflow = track.scrollWidth > track.clientWidth + 4;
      nav.classList.toggle('has-overflow', overflow);
      if (prevBtn) prevBtn.hidden = !overflow || track.scrollLeft <= 4;
      if (nextBtn) nextBtn.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      nav.classList.toggle('fade-start', overflow && track.scrollLeft > 4);
      nav.classList.toggle('fade-end', overflow && track.scrollLeft + track.clientWidth < track.scrollWidth - 4);
    }
    if (mode === 'more' && links.length > 6) {
      /* collapse tabs 7+ into a details "More" menu */
      var more = document.createElement('li');
      more.className = 'pdp-tabs__more';
      var det = document.createElement('details');
      var sum = document.createElement('summary');
      sum.textContent = (nav.getAttribute('data-more-label') || 'More') + ' ▾';
      var menu = document.createElement('ul');
      menu.className = 'pdp-tabs__more-menu list-unstyled';
      links.slice(6).forEach(function (l) {
        var li = l.parentElement;
        menu.appendChild(li);
      });
      det.appendChild(sum);
      det.appendChild(menu);
      more.appendChild(det);
      track.appendChild(more);
      document.addEventListener('click', function (e) {
        if (!det.contains(e.target)) det.removeAttribute('open');
        if (e.target.closest('.pdp-tabs__more-menu [data-tab-link]')) det.removeAttribute('open');
      });
    } else if (track) {
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -160, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: 160, behavior: 'smooth' }); });
      var navRaf = null;
      function queueNavOverflow() {
        if (navRaf) return;
        navRaf = requestAnimationFrame(function () { navRaf = null; updateNavOverflow(); });
      }
      track.addEventListener('scroll', queueNavOverflow, { passive: true });
      window.addEventListener('resize', queueNavOverflow, { passive: true });
      updateNavOverflow();
    }
    if ('IntersectionObserver' in window && panels.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-30% 0px -60% 0px' }
      );
      panels.forEach(function (p) { observer.observe(p); });
    }
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('[data-tab-link]');
      if (!link) return;
      e.preventDefault();
      var target = document.querySelector(link.getAttribute('href'));
      if (target) {
        var y = target.getBoundingClientRect().top + window.scrollY - (nav.offsetHeight + 80);
        window.scrollTo({ top: y, behavior: 'smooth' });
        /* a deliberately chosen tab should show its content, not a closed
           accordion (e.g. Warranty & returns) */
        var det = target.querySelector('details');
        if (det) det.open = true;
        target.classList.add('is-open');
        var tg = target.querySelector('.pdp-tabs__toggle');
        if (tg) tg.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---- copy buttons ---- */
  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-copy-value]');
    if (!copy) return;
    var value = copy.getAttribute('data-copy-value');
    var done = function (ok) {
      copy.classList.add(ok ? 'is-copied' : 'is-failed');
      copy.setAttribute('aria-label', ok ? 'Copied' : 'Copy failed');
      setTimeout(function () { copy.classList.remove('is-copied', 'is-failed'); }, 1200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(function () { done(true); }, function () { done(false); });
    } else {
      done(false);
    }
  });

  /* ---- price-break row highlight follows the buy-box qty ---- */
  function highlightBreaks(qty) {
    var rows = document.querySelectorAll('[data-break-row]');
    if (!rows.length) return;
    var winner = null;
    rows.forEach(function (row) {
      var min = parseInt(row.getAttribute('data-min'), 10) || 1;
      if (qty >= min) winner = row;
    });
    rows.forEach(function (row) { row.classList.toggle('is-active', row === winner); });
  }
  var qtyInput = document.querySelector('.product-form__input input[name="quantity"], .quantity__input');
  if (qtyInput) {
    highlightBreaks(parseInt(qtyInput.value, 10) || 1);
    ['change', 'input'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (e.target.matches('.quantity__input, input[name="quantity"]')) {
          highlightBreaks(parseInt(e.target.value, 10) || 1);
        }
      });
    });
  }

  /* ---- FBT: total + add-all ---- */
  document.querySelectorAll('[data-fbt]').forEach(function (fbt) {
    var total = fbt.querySelector('[data-fbt-total]');
    var base = parseInt(total ? total.getAttribute('data-base-price') : '0', 10) || 0;
    function refreshTotal() {
      var sum = base;
      fbt.querySelectorAll('[data-fbt-check]:checked').forEach(function (c) {
        sum += parseInt(c.getAttribute('data-price'), 10) || 0;
      });
      if (total) total.textContent = '$' + (sum / 100).toFixed(2);
    }
    refreshTotal();
    fbt.addEventListener('change', refreshTotal);

    var addAll = fbt.querySelector('[data-fbt-add-all]');
    if (addAll) {
      addAll.addEventListener('click', function () {
        if (addAll.hasAttribute('data-busy')) return;
        addAll.setAttribute('data-busy', '');
        var label = addAll.textContent;
        addAll.textContent = ((window.b2bStrings || {}).adding || 'Adding…');
        var items = [];
        var always = fbt.querySelector('[data-fbt-variant]');
        if (always) items.push({ id: parseInt(always.value, 10), quantity: 1 });
        fbt.querySelectorAll('[data-fbt-check]:checked').forEach(function (c) {
          items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            addAll.textContent = ((window.b2bStrings || {}).added || 'Added');
            setTimeout(function () { addAll.textContent = label; addAll.removeAttribute('data-busy'); }, 1500);
          })
          .catch(function () {
            addAll.textContent = ((window.b2bStrings || {}).tryAgain || 'Try again');
            setTimeout(function () { addAll.textContent = label; addAll.removeAttribute('data-busy'); }, 1500);
          });
      });
    }
  });

  /* ---- add to list (buy box) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product__add-to-list[data-add-to-list]');
    if (!btn) return;
    e.preventDefault();
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem('saved-for-later') || '[]'); } catch (err) {}
    var id = btn.getAttribute('data-variant-id');
    if (!saved.some(function (s) { return String(s.variantId) === id; })) {
      saved.push({
        variantId: id,
        title: btn.getAttribute('data-item-title'),
        price: btn.getAttribute('data-item-price'),
        url: btn.getAttribute('data-item-url')
      });
      try { localStorage.setItem('saved-for-later', JSON.stringify(saved)); } catch (err) {}
    }
    var original = btn.textContent;
    btn.textContent = ((window.b2bStrings || {}).savedToList || 'Saved to list ✓');
    setTimeout(function () { btn.textContent = original; }, 1500);
  });
})();

/* ================= Elite PDP extras ================= */
(function () {
  'use strict';

  /* ---------- quantity presets from the price-break tiers ---------- */
  var qtyEl = document.querySelector('.product-form__input input[name="quantity"], .quantity__input');
  var breakRows = document.querySelectorAll('[data-break-row]');
  var buildPresets = function () {
  breakRows = document.querySelectorAll('[data-break-row]');
  var oldWrap = document.querySelector('.product__qty-presets');
  if (oldWrap) oldWrap.remove();
  /* one code path: presets render ONLY into the "Quantity presets" block slot,
     always built from the volume-pricing tiers on the page */
  var presetSlot = document.querySelector('[data-qty-presets-slot]');
  if (presetSlot && qtyEl && breakRows.length && !document.querySelector('.product__qty-presets')) {
    var presets = Array.from(breakRows).map(function (r) {
      return parseInt(r.getAttribute('data-min'), 10) || 1;
    });
    var wrap = document.createElement('div');
    wrap.className = 'product__qty-presets';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', (window.b2bStrings || {}).qtyPresets || 'Quantity presets');
    presets.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product__qty-preset' + (n === 1 ? ' is-active' : '');
      b.setAttribute('aria-pressed', n === 1 ? 'true' : 'false');
      b.textContent = n;
      b.addEventListener('click', function () {
        qtyEl.value = n;
        qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrap.appendChild(b);
    });
    /* the block is the gate; the presets mount INSIDE Dawn's quantity form right after
       its label so the label stays owned by the form (Dawn updates "(n in cart)" there)
       and the group reads label -> presets -> stepper */
    var qtyLabel = document.querySelector('.product__info-wrapper #Quantity-Form-' + (qtyEl.dataset.section || '') + ' .quantity__label, .product__info-wrapper .product-form__quantity .quantity__label');
    if (qtyLabel) qtyLabel.insertAdjacentElement('afterend', wrap);
    else presetSlot.appendChild(wrap);
    qtyEl.addEventListener('change', function () {
      var v = parseInt(qtyEl.value, 10) || 1;
      wrap.querySelectorAll('.product__qty-preset').forEach(function (p) {
        var on = parseInt(p.textContent, 10) === v;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }
  };
  buildPresets();

  /* one quantity, four readers (input, presets, price line, tier row): after an
     add-to-cart Dawn re-renders the quantity rules and resets the input silently,
     so re-announce the value through the input's own change event */
  var syncQtyUi = function () {
    if (!qtyEl) return;
    qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncQtyUi, 400); setTimeout(syncQtyUi, 1200); });
    if (PUB_SUB_EVENTS.quantityUpdate) subscribe(PUB_SUB_EVENTS.quantityUpdate, function () { setTimeout(syncQtyUi, 0); });
  }
  document.addEventListener('cart:refresh', function () { setTimeout(syncQtyUi, 400); });

  /* ---------- effective price for the chosen quantity (tier unit price + line total) ---------- */
  var qtyPriceEl = document.querySelector('[data-qty-price]');
  var renderQtyPrice = function () {};
  var initQtyPrice = function () {
  breakRows = document.querySelectorAll('[data-break-row]');
  /* always reset first: a variant with no tiers must not inherit the previous variant's closure */
  renderQtyPrice = function () {};
  var noteReset = document.querySelector('[data-qty-price-note]');
  if (noteReset) noteReset.hidden = true;
  if (qtyPriceEl) {
    qtyPriceEl.hidden = true;
    qtyPriceEl.textContent = '';
    delete qtyPriceEl.dataset.unit;
    delete qtyPriceEl.dataset.total;
    delete qtyPriceEl.dataset.qty;
    document.dispatchEvent(new CustomEvent('qty-price:change'));
  }
  if (qtyEl && qtyPriceEl && breakRows.length) {
    var parseMoney = function (txt) {
      var m = /([^\d\s]*)\s*([\d.,]+)/.exec(txt || '');
      if (!m) return null;
      var num = parseFloat(m[2].replace(/,/g, ''));
      return isNaN(num) ? null : { symbol: m[1] || '', value: num };
    };
    var fmt = function (symbol, value) {
      return symbol + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    var tiers = Array.from(breakRows).map(function (r) {
      var cell = r.children[1];
      return { min: parseInt(r.getAttribute('data-min'), 10) || 1, price: parseMoney(cell ? cell.textContent : '') };
    }).filter(function (t) { return t.price; }).sort(function (a, b) { return a.min - b.min; });
    renderQtyPrice = function () {
      var q = parseInt(qtyEl.value, 10) || 1;
      var tier = null;
      tiers.forEach(function (t) { if (q >= t.min) tier = t; });
      var noteEl = document.querySelector('[data-qty-price-note]');
      if (!tier || q < 2) { qtyPriceEl.hidden = true; qtyPriceEl.textContent = ''; delete qtyPriceEl.dataset.unit; if (noteEl) noteEl.hidden = true; return; }
      var unit = fmt(tier.price.symbol, tier.price.value);
      var total = fmt(tier.price.symbol, tier.price.value * q);
      var tpl = qtyPriceEl.getAttribute('data-template') || '{unit} / ea for {qty}';
      qtyPriceEl.textContent = tpl.replace('{unit}', unit).replace('{total}', total).replace('{qty}', q);
      qtyPriceEl.dataset.unit = unit;
      qtyPriceEl.dataset.total = total;
      qtyPriceEl.dataset.qty = q;
      qtyPriceEl.hidden = false;
      /* display-only tiers (pricing.breaks) carry the merchant's note; enforced variant rules do not */
      if (noteEl) {
        var srcEl = document.querySelector('[data-price-breaks]');
        noteEl.hidden = !(srcEl && srcEl.getAttribute('data-tiers-source') === 'metafield');
      }
      document.dispatchEvent(new CustomEvent('qty-price:change'));
    };
    renderQtyPrice();
  }
  };
  initQtyPrice();
  if (qtyEl) {
    qtyEl.addEventListener('change', function () { renderQtyPrice(); });
    qtyEl.addEventListener('input', function () { renderQtyPrice(); });
  }

  /* ---------- variant change: re-render the B2B blocks from the fetched section, then re-init ---------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var html = e && e.data && e.data.html;
      if (!html) return;
      html.querySelectorAll('[data-b2b-block]').forEach(function (src) {
        var dest = document.querySelector('[data-b2b-block="' + src.getAttribute('data-b2b-block') + '"]');
        if (dest) dest.innerHTML = src.innerHTML;
      });
      /* pill legends show the selected value */
      document.querySelectorAll('.product-options .product-form__input--pill').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-selected-value]');
        if (checked && out) out.textContent = checked.value;
      });
      buildPresets();
      initQtyPrice();
      if (typeof initCountdown === 'function') initCountdown();
      if (window.b2bDelivery && window.b2bDelivery.refresh) window.b2bDelivery.refresh();
    });
  }

  /* ---------- cutoff countdown (Eastern Time, from shipping_rules) ---------- */
  var countdownTimer = null;
  function initCountdown() {
  var countdown = document.querySelector('[data-cutoff-countdown]');
  var rulesEl = document.querySelector('[data-shipping-rules]');
  if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  if (countdown && rulesEl) {
    var rules = {};
    try { rules = JSON.parse(rulesEl.textContent); } catch (e) {}
    var m = /(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i.exec(rules.cutoffTime || '');
    if (m) {
      var cutoffMin = ((parseInt(m[1], 10) % 12) + (/pm/i.test(m[3]) ? 12 : 0)) * 60 + (m[2] ? parseInt(m[2], 10) : 0);
      var tick = function () {
        var nowEt;
        try { nowEt = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { nowEt = new Date(); }
        var mins = cutoffMin - (nowEt.getHours() * 60 + nowEt.getMinutes());
        var dow = nowEt.getDay();
        if (mins > 0 && dow !== 0 && dow !== 6) {
          var tpl = countdown.getAttribute('data-template') || 'Order in {h}h {m}m to ship today';
          countdown.textContent = tpl
            .replace('{h}', Math.floor(mins / 60))
            .replace('{m}', mins % 60);
          countdown.hidden = false;
        } else {
          countdown.hidden = true;
        }
      };
      tick();
      countdownTimer = setInterval(tick, 30000);
    }
  }
  }
  initCountdown();

  /* ---------- bulk quote modal ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-quote-open]');
    if (open) {
      var modal = document.querySelector('[data-quote-modal]');
      if (modal) {
        modal.hidden = false;
        modal._returnFocus = open;
        var first = modal.querySelector('input, textarea, button');
        if (first) first.focus();
        if (window.trapModalFocus) window.trapModalFocus(modal);
      }
      return;
    }
    var qm = document.querySelector('[data-quote-modal]');
    if (qm && !qm.hidden && (e.target.closest('[data-quote-close]') || e.target === qm)) {
      qm.hidden = true;
      if (qm._returnFocus) { qm._returnFocus.focus(); qm._returnFocus = null; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var qm = document.querySelector('[data-quote-modal]');
    if (qm && !qm.hidden) {
      qm.hidden = true;
      if (qm._returnFocus) { qm._returnFocus.focus(); qm._returnFocus = null; }
    }
  }, true);

  /* ---------- share menu (details/summary) ---------- */
  function closeShareMenus(returnFocus) {
    document.querySelectorAll('.pdp-share-menu[open]').forEach(function (d) {
      d.removeAttribute('open');
      if (returnFocus) { var s = d.querySelector('summary'); if (s) s.focus(); }
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeShareMenus(true);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.pdp-share-menu')) closeShareMenus(false);
    var cp = e.target.closest('[data-copy-link]');
    if (!cp) return;
    var url = cp.getAttribute('data-share-url');
    var menu = cp.closest('details');
    var status = menu && menu.querySelector('[data-copy-status]');
    var done = function () {
      var old = cp.textContent; cp.textContent = cp.getAttribute('data-copied') || old;
      if (status) status.textContent = cp.getAttribute('data-copied') || '';
      setTimeout(function () {
        cp.textContent = old;
        if (status) status.textContent = '';
        if (menu) menu.removeAttribute('open');
      }, 1200);
    };
    var fallback = function () {
      /* no async clipboard (older browsers, non-secure context): select the text and use execCommand, else prompt */
      var ta = document.createElement('textarea');
      ta.value = url; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
      document.body.removeChild(ta);
      if (ok) done(); else window.prompt('', url);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
    else fallback();
  });

  /* ---------- mobile: tab panels collapse to accordions ---------- */
  var mq = window.matchMedia('(max-width: 749px)');
  function setupAccordions() {
    document.querySelectorAll('[data-tab-panel]').forEach(function (panel, index) {
      var heading = panel.querySelector('.pdp-tabs__heading');
      if (!heading) return;
      /* the heading stays a heading; a real <button> inside it is the toggle and
         controls a single body wrapper (built once, on first mobile match) */
      var btn = heading.querySelector('.pdp-tabs__toggle');
      if (mq.matches) {
        if (!btn) {
          var bodyId = (panel.id || 'tab-' + index) + '-body';
          var body = panel.querySelector('.pdp-tabs__body');
          if (!body) {
            body = document.createElement('div');
            body.className = 'pdp-tabs__body';
            body.id = bodyId;
            var next = heading.nextSibling;
            while (next) { var n = next.nextSibling; body.appendChild(next); next = n; }
            panel.appendChild(body);
          }
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pdp-tabs__toggle';
          btn.setAttribute('aria-controls', bodyId);
          while (heading.firstChild) btn.appendChild(heading.firstChild);
          heading.appendChild(btn);
          btn.addEventListener('click', function () {
            if (!mq.matches) return;
            panel.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');
          });
        }
        btn.disabled = false;
        panel.dataset.accBtn = '1';
        /* per-block "open by default on mobile" setting; first panel falls
           back to open when no block opts in. Reset first so a desktop->mobile
           resize doesn't leave everything open. */
        panel.classList.remove('is-open');
        if (panel.getAttribute('data-mobile-open') === 'true') panel.classList.add('is-open');
        if (index === 0 && !document.querySelector('[data-tab-panel][data-mobile-open="true"]')) {
          panel.classList.add('is-open');
        }
        btn.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');
      } else {
        panel.classList.add('is-open');
        /* desktop: unwrap the text back into the plain heading (rebuilt on the next mobile match) */
        if (btn) {
          while (btn.firstChild) heading.appendChild(btn.firstChild);
          btn.remove();
        }
      }
    });
  }
  setupAccordions();
  mq.addEventListener('change', setupAccordions);

  /* ---------- optional muted autoplay for the first product video ---------- */
  if (window.b2bFlags && window.b2bFlags.videoAutoplay) {
    var deferred = document.querySelector('.product__media-wrapper deferred-media');
    if (deferred) {
      var poster = deferred.querySelector('[id^="Deferred-Poster"]');
      if (poster) poster.click();
      setTimeout(function () {
        var vid = deferred.querySelector('video');
        if (vid) { vid.muted = true; vid.play().catch(function () {}); }
      }, 800);
    }
  }

  /* ---------- record recently viewed (rendered on PLPs) ---------- */
  try {
    var main = document.querySelector('.product__info-container');
    if (main && window.location.pathname.indexOf('/products/') !== -1) {
      /* Prefer the h1 specifically, not its .product__title wrapper - the
         wrapper's textContent also picks up other nested text (brand chip,
         badges, a responsive duplicate heading), which duplicated the title
         string end to end. Falls back to the wrapper only if no h1 exists. */
      var titleEl = document.querySelector('.product__title h1') || document.querySelector('.product__title');
      var entry = {
        handle: window.location.pathname.split('/products/')[1].split(/[/?#]/)[0],
        title: titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '',
        brand: ((document.querySelector('.product__brand') || {}).textContent || '').trim(),
        price: ((document.querySelector('.price__regular .price-item--regular') || {}).textContent || '').trim(),
        image: (function () {
          var img = document.querySelector('.product__media img, .product-media-container img');
          return img ? (img.currentSrc || img.src) : '';
        })(),
        url: window.location.pathname
      };
      var seen = JSON.parse(localStorage.getItem('recently-viewed') || '[]');
      seen = seen.filter(function (s) { return s.handle !== entry.handle; });
      seen.unshift(entry);
      localStorage.setItem('recently-viewed', JSON.stringify(seen.slice(0, 12)));
    }
  } catch (e) {}

  /* ---------- mobile sticky ATC: visible only while the buy-box CTA is off-screen;
     price + availability follow variant changes ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var submit = document.querySelector('.product-form__submit');
    var mq = window.matchMedia('(max-width: 749px)');
    var apply = function (show) {
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('has-sticky-atc', show);
      /* hidden bar leaves the tab order / accessibility tree */
      if (show) { bar.removeAttribute('aria-hidden'); bar.removeAttribute('inert'); }
      else { bar.setAttribute('aria-hidden', 'true'); bar.setAttribute('inert', ''); }
    };
    /* show once the buy-box CTA has scrolled above the viewport; hide while it is in
       view or still below (a scroll check, not IntersectionObserver: a jump past the
       element never produces an intersection change) */
    var ticking = false;
    var check = function () {
      ticking = false;
      if (!submit) { apply(mq.matches); return; }
      /* shown only once the buy-box CTA has scrolled above the viewport (big-store
         pattern); at page load the gallery and pager stay uncovered */
      var r = submit.getBoundingClientRect();
      /* the bar shows whenever the buy-box CTA is off-screen (scrolled above, or still below the first phone screen),
         so exactly one Add to cart is ever visible */
      /* review 48: also while the in-page button is only partly on the first screen, so a buy button is always tappable */
      apply(mq.matches && (r.bottom < 0 || r.bottom > window.innerHeight));
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mq.addEventListener('change', onScroll);
    check();
    var priceEl = bar.querySelector('[data-sticky-price]');
    var btn = bar.querySelector('[data-sticky-button]');
    var sync = function () {
      if (priceEl) {
        var live = document.querySelector('.product__info-wrapper .price__sale .price-item--last, .product__info-wrapper .price__regular .price-item--regular');
        var qp = document.querySelector('[data-qty-price]');
        if (qp && !qp.hidden && qp.dataset.unit) priceEl.textContent = qp.textContent;
        else if (live) priceEl.textContent = live.textContent.trim();
      }
      var stockEl = bar.querySelector('[data-sticky-stock]');
      if (stockEl) {
        var stock = document.querySelector('[data-delivery-block] .product__stock');
        var est = document.querySelector('[data-delivery-block] [data-get-it-by]:not([hidden])');
        var lead = document.querySelector('[data-delivery-block] .product__lead-time');
        var txt = stock ? stock.textContent.trim() : '';
        /* one promise on the screen: the dated estimate when delivery.js has filled it, else the lead-time line */
        /* the bar's line is the estimate alone ("Get it by Thu, Oct 29"): in-stock is already the green colour */
        if (est && est.textContent.trim()) txt = est.textContent.replace(/\s+/g, ' ').replace(/^[—–-]\s*/, '').trim().replace(/^get it by/i, 'Get it by');
        else if (lead) txt += ' ' + lead.textContent.replace(/\s+/g, ' ').trim();
        /* the date never breaks mid-value: "Get it by " + <span class="product-sticky-atc__date">Thu, Oct 29</span> */
        var dm = /^(Get it by )(.+)$/.exec(txt);
        stockEl.textContent = '';
        if (dm) { stockEl.appendChild(document.createTextNode(dm[1])); var ds = document.createElement('span'); ds.className = 'product-sticky-atc__date'; ds.textContent = dm[2]; stockEl.appendChild(ds); }
        else stockEl.textContent = txt;
        stockEl.hidden = !txt;
        stockEl.classList.toggle('is-in', !!(stock && stock.classList.contains('product__stock--in')));
        stockEl.classList.toggle('is-out', !!(stock && stock.classList.contains('product__stock--out')));
      }
      var form = document.querySelector('.product-form__submit');
      /* sold out comes from the selected variant (Dawn's JSON, replaced on every variant
         change), never from the submit's disabled attribute: delivery.js also disables
         the submit for a blocked ZIP and marks it with data-zip-disabled */
      var out = (function () {
        var vs = document.querySelector('.product__info-wrapper variant-selects [data-selected-variant]');
        if (vs) {
          try { var v = JSON.parse(vs.textContent); return !(v && v.available); } catch (e) {}
        }
        return form ? (form.disabled && !form.hasAttribute('data-zip-disabled')) : false; /* single-variant products */
      })();
      var zipBlocked = !!(form && (form.hasAttribute('data-zip-disabled') || form.hasAttribute('data-size-pending')));
      /* belt and braces: a sold-out variant's main CTA is never left enabled */
      if (form && out && !form.disabled) form.disabled = true;
      if (btn) {
        /* the sticky button submits the same form: it is never enabled while the main CTA is blocked */
        var dis = out || zipBlocked;
        if (btn.disabled !== dis) btn.disabled = dis;
        btn.textContent = out ? (bar.getAttribute('data-label-out') || '') : (bar.getAttribute('data-label-add') || '');
      }
      /* sold out: quantity controls and dynamic checkout follow the CTA. Write only on
         change: re-setting an attribute still queues a mutation record and would loop
         the observer below every frame. */
      document.querySelectorAll('.product__qty-preset, .product__info-wrapper .quantity__input, .product__info-wrapper .quantity__button').forEach(function (el) { if (el.disabled !== out) el.disabled = out; });
      document.querySelectorAll('.product__info-wrapper .shopify-payment-button').forEach(function (el) { if (el.hidden !== out) el.hidden = out; });
      document.querySelectorAll('[data-sold-out-help]').forEach(function (el) { if (el.hidden !== !out) el.hidden = !out; });
    };
    document.addEventListener('delivery:updated', sync);
    document.addEventListener('qty-price:change', sync);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
    }
    var info = document.querySelector('product-info');
    /* ZIP link reads "Enter ZIP..." until a ZIP is saved, then "Change ZIP" */
    /* re-query every time: the delivery block is re-rendered on variant change */
    var zipLabel = function () {
      var zipBtn = document.querySelector('.product__change-zip');
      if (!zipBtn) return;
      var zip = '';
      try { zip = localStorage.getItem('delivery-zip') || ''; } catch (e) {}
      zipBtn.textContent = zip ? (zipBtn.getAttribute('data-label-change') || '') : (zipBtn.getAttribute('data-label-enter') || '');
    };
    zipLabel();
    document.addEventListener('zip:change', zipLabel);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(zipLabel, 0); });
    }
    sync(); /* landing state (e.g. ?variant= of a sold-out variant) matches the post-change state */
    if (info && 'MutationObserver' in window) {
      var syncQueued = false;
      /* watch the submit button's disabled state (Dawn toggles it during fetches / sold out);
         re-rendered blocks are covered by the variantChange subscription above */
      var submitEl = document.querySelector('.product-form__submit');
      new MutationObserver(function () {
        if (syncQueued) return;
        syncQueued = true;
        window.requestAnimationFrame(function () { syncQueued = false; sync(); });
      }).observe(submitEl || info, submitEl ? { attributes: true, attributeFilter: ['disabled'] } : { childList: true, subtree: true });
    }
  })();
})();
}

/* ---------- Desktop sticky product header (inside the sticky tab nav): shown while the nav is stuck
   and the buy-box CTA is above the viewport; price, quantity and availability mirror the buy box ---------- */
(function () {
  var head = document.querySelector('[data-pdp-sticky-head]');
  if (!head) return;
  var nav = head.closest('.pdp-tabs__nav');
  var tabs = head.closest('.pdp-tabs');
  if (!nav) return;
  var mq = window.matchMedia('(min-width: 750px)');
  var submit = function () { return document.querySelector('.product-form__submit'); };
  var hdrSec = (function () { var sh = document.querySelector('sticky-header'); return sh ? (sh.closest('.shopify-section') || sh) : null; })();
  var ticking = false;
  var dock = parseFloat(getComputedStyle(nav).top) || 0;
  var headH = 66;
  var lastTop = null;
  /* written on the tabs container so both the nav (top) and the panels (scroll-margin-top) inherit it */
  var setTop = function (v) { if (v === lastTop) return; lastTop = v; (tabs || nav).style.setProperty('--pdp-nav-top', v + 'px'); };
  var check = function () {
    ticking = false;
    var show = false;
    if (mq.matches) {
      /* the nav docks under whatever the sticky site header measures right now: taller at tablet widths,
         0 while Dawn has slid it away on scroll-down */
      if (hdrSec) {
        var hr = hdrSec.getBoundingClientRect();
        if (hr.top <= 0) dock = Math.max(0, Math.min(200, Math.round(hr.bottom)));
      }
      /* the bar overlays the space above the nav, so the nav docks lower by the bar's height while it is shown */
      var top = dock + (head.hidden ? 0 : headH);
      setTop(top);
      var stuck = nav.getBoundingClientRect().top <= top + 1;
      var s = submit();
      var past = s ? s.getBoundingClientRect().bottom < 0 : true;
      show = stuck && past;
    }
    if (head.hidden === !show) return;
    head.hidden = !show;
    nav.classList.toggle('has-head', show);
    if (tabs) tabs.classList.toggle('has-head', show);
    if (show) headH = head.offsetHeight || headH;
    setTop(dock + (show ? headH : 0));
  };
  var onScroll = function () { if (ticking) return; ticking = true; window.requestAnimationFrame(check); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  mq.addEventListener('change', onScroll);
  /* Dawn slides the header in and out with a ~220ms transition: one coalesced follow loop re-docks meanwhile */
  if (hdrSec) {
    var followUntil = 0, following = false;
    var follow = function () {
      followUntil = performance.now() + 300;
      if (following) return;
      following = true;
      var tick = function () { check(); if (performance.now() < followUntil) window.requestAnimationFrame(tick); else following = false; };
      window.requestAnimationFrame(tick);
    };
    hdrSec.addEventListener('transitionend', onScroll);
    if ('MutationObserver' in window) new MutationObserver(follow).observe(hdrSec, { attributes: true, attributeFilter: ['class'] });
  }
  check();
  /* price + pack note + button state follow the buy box */
  var priceEl = head.querySelector('[data-sticky-head-price]');
  var packEl = head.querySelector('[data-sticky-head-pack]');
  var btn = head.querySelector('[data-sticky-head-add]');
  var qty = parseInt(head.dataset.packQty, 10) || 0;
  var fmt = function (cents) {
    var str = head.dataset.moneyFormat || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    return str.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  var sync = function () {
    if (priceEl) {
      /* same source as the mobile bar: the quantity-break price when active, else the live price (never the struck compare-at) */
      var qp = document.querySelector('[data-qty-price]');
      var live = document.querySelector('.product__info-wrapper .price__sale .price-item--last, .product__info-wrapper .price__regular span.price-item--regular:not(s)');
      if (qp && !qp.hidden && qp.dataset.unit) priceEl.textContent = qp.textContent.trim();
      else if (live) priceEl.textContent = live.textContent.trim();
    }
    if (packEl && qty > 1) {
      var vs = document.querySelector('.product__info-wrapper variant-selects [data-selected-variant]');
      var v = null;
      if (vs) { try { v = JSON.parse(vs.textContent); } catch (e) {} }
      if (v && typeof v.price === 'number') {
        /* rounded to the cent, like the Liquid in the buy box and the bar */
        var cents = Math.round(v.price / qty);
        var each = cents >= 10 ? fmt(cents) : fmt(0).replace(/0[.,]00/, '0.' + ('00' + Math.round(v.price * 10 / qty)).slice(-3));
        var txt = (head.dataset.packLabel || '').replace('[n]', String(qty)).replace('[each]', each);
        packEl.textContent = txt;
        var bb = document.querySelector('[data-pack-each]');
        if (bb) bb.textContent = txt;
      }
    }
    var s = submit();
    if (btn && s) {
      var out = s.disabled;
      if (btn.disabled !== out) btn.disabled = out;
      var lbl = s.querySelector('span');
      btn.textContent = out ? (lbl ? lbl.textContent.trim() : btn.dataset.labelOut) : btn.dataset.labelAdd;
    }
  };
  sync();
  document.addEventListener('qty-price:change', sync);
  document.addEventListener('delivery:updated', sync);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
  }
  var s0 = submit();
  if (s0 && 'MutationObserver' in window) {
    new MutationObserver(function () { window.requestAnimationFrame(sync); }).observe(s0, { attributes: true, attributeFilter: ['disabled'] });
  }
  /* quantity: the bar's stepper and the buy-box input are one value */
  var qtyIn = document.querySelector('.product__info-wrapper input[name="quantity"], .product-form__quantity input[name="quantity"]');
  var hq = head.querySelector('[data-sticky-head-qty]');
  if (qtyIn && hq) {
    var syncQty = function () { if (qtyIn.max) hq.max = qtyIn.max; if (document.activeElement !== hq) hq.value = qtyIn.value; };
    syncQty();
    qtyIn.addEventListener('change', syncQty);
    qtyIn.addEventListener('input', syncQty);
    hq.addEventListener('change', function () {
      var v = Math.max(parseInt(hq.value, 10) || 1, parseInt(qtyIn.min, 10) || 1);
      hq.value = v; qtyIn.value = v; qtyIn.dispatchEvent(new Event('change', { bubbles: true }));
    });
    head.querySelectorAll('[data-sticky-head-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(qtyIn.step, 10) || 1;
        var v = (parseInt(hq.value, 10) || 1) + (b.dataset.stickyHeadQtyStep === 'plus' ? step : -step);
        hq.value = Math.max(v, parseInt(qtyIn.min, 10) || 1);
        hq.dispatchEvent(new Event('change'));
      });
    });
  } else if (hq) {
    hq.closest('.pdp-sticky-head__qty').hidden = true;
  }
  if (btn) {
    btn.addEventListener('click', function () {
      var s = submit();
      if (!s || s.disabled) return;
      /* the buy-box quantity (mirrored above) is what gets added; Dawn's product-form handles the request */
      s.click();
    });
  }
  var top = head.querySelector('[data-sticky-head-top]');
  if (top) {
    top.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      /* keyboard users land where they act: the buy-box quantity, else the title */
      var target = qtyIn || document.querySelector('.product__title h1, h1');
      if (target) { if (target.tagName !== 'INPUT') target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    });
  }
})();

/* ---------- Merged size products: default size rule, "choose a size" mode, size chart modal, sticky size ---------- */
(function () {
  var box = document.querySelector('[data-product-options]');
  if (!box) return;
  var mode = box.dataset.defaultMode || 'preferred';
  var radios = function () { return Array.prototype.slice.call(box.querySelectorAll('.product-form__input--pill input[type="radio"]')); };
  var submit = function () { return document.querySelector('.product-form__submit'); };
  var required = box.querySelector('[data-size-required]');
  var hasVariantParam = /[?&]variant=/.test(location.search);
  /* the default pick is a real selection: wait until Dawn's product-info / variant-selects elements are
     defined so the click re-renders price, identifiers, stock and the URL like a shopper's click would */
  var whenReady = function (fn) {
    Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects'), customElements.whenDefined('product-form')]).then(function () { setTimeout(fn, 0); });
  };
  var choose = function (r) {
    if (!r || r.checked) return;
    r.click(); /* a click on an unchecked radio already dispatches change: one fetch, no AbortError */
    r.blur(); /* no focus ring from a pick the shopper did not make */
  };
  if (!hasVariantParam && radios().length) whenReady(function () {
    if (mode === 'preferred') {
      var prefs = (box.dataset.preferredSizes || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      var avail = radios().filter(function (r) { return !r.classList.contains('disabled'); });
      var pick = null;
      prefs.some(function (pv) { pick = avail.find(function (r) { return r.value.trim().toLowerCase() === pv; }) || null; return !!pick; });
      if (!pick && avail.length) pick = avail[0];
      choose(pick);
    } else if (mode === 'first') {
      choose(radios().find(function (r) { return !r.classList.contains('disabled'); }));
    } else if (mode === 'force') {
      radios().forEach(function (r) { r.checked = false; });
      box.querySelectorAll('[data-selected-value]').forEach(function (el) { el.textContent = ''; });
      /* both Add buttons (buy box + mobile bar) wait for a size; delivery.js and the sticky sync honour data-size-pending */
      var pending = function () { return document.querySelectorAll('.product-form__submit, [data-sticky-button], [data-sticky-head-add]'); };
      pending().forEach(function (b) { b.disabled = true; b.setAttribute('data-size-pending', ''); });
      if (required) required.hidden = false;
      box.addEventListener('change', function () {
        if (required) required.hidden = true;
        pending().forEach(function (b) { b.removeAttribute('data-size-pending'); });
      }, { once: true });
    }
  });
  /* size chart: the article's body is loaded into the modal on first open; the link stays as a fallback */
  var chartBody = document.querySelector('[data-size-chart-body]');
  var opener = box.querySelector('.product-options__chart');
  if (chartBody && opener) {
    var loaded = false;
    opener.addEventListener('click', function (e) {
      /* the opener is a real link for crawlers and no-JS; with JS the modal takes over (Dawn's modal-opener only binds a <button>) */
      e.preventDefault();
      var modal = document.querySelector(opener.dataset.modal);
      if (modal && typeof modal.show === 'function') modal.show(opener.querySelector('a') || opener);
      if (loaded) return;
      loaded = true;
      /* same-origin only: the setting is free text, an external URL keeps the plain link fallback */
      var u;
      try { u = new URL(chartBody.dataset.sizeChartUrl, location.origin); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      fetch(u.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        /* the article body only (never the hero, breadcrumb or page H1): selectors tried in order of preference */
        var src = null;
        ['.article-template__content', 'main .rte', 'article'].some(function (sel) { src = doc.querySelector(sel); return !!src; });
        if (!src) return;
        src.querySelectorAll('script, iframe, form, object, embed, h1, .breadcrumbs, .article-template__hero-container').forEach(function (el) { el.remove(); });
        src.querySelectorAll('*').forEach(function (el) {
          Array.prototype.slice.call(el.attributes).forEach(function (a) {
            if (/^on/i.test(a.name) || ((a.name === 'href' || a.name === 'src') && /^\s*javascript:/i.test(a.value))) el.removeAttribute(a.name);
          });
        });
        chartBody.textContent = '';
        var h = doc.querySelector('h1');
        if (h) { var h2 = document.createElement('h2'); h2.className = 'h3'; h2.textContent = h.textContent.trim(); chartBody.appendChild(h2); }
        while (src.firstChild) chartBody.appendChild(src.firstChild);
        /* the link promises a chart: open on the first table, not the article intro */
        var table = chartBody.querySelector('table');
        var scroller = chartBody.closest('.product-popup-modal__content');
        if (table && scroller) window.requestAnimationFrame(function () { scroller.scrollTop = Math.max(0, table.offsetTop - scroller.offsetTop - 24); });
      }).catch(function () {});
    });
  }
  /* sticky bars show the selected size */
  var syncVariant = function () {
    var vs = document.querySelector('.product__info-wrapper variant-selects [data-selected-variant]');
    var v = null;
    if (vs) { try { v = JSON.parse(vs.textContent); } catch (e) {} }
    if (!v) return;
    document.querySelectorAll('[data-sticky-variant], [data-sticky-head-variant]').forEach(function (el) { el.textContent = v.title || ''; });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncVariant, 0); });
  }
})();

/* ---------- PDP upgrade 2026-10-23: recently viewed section, sticky bar title/qty, back-in-stock ---------- */
(function () {
  /* Recently viewed (same localStorage key pdp-b2b.js writes above), current product excluded */
  var wrap = document.querySelector('[data-pdp-recently-viewed]');
  if (wrap && !wrap.dataset.filled) {
    wrap.dataset.filled = '1';
    var seen = [];
    try { seen = JSON.parse(localStorage.getItem('recently-viewed') || '[]'); } catch (e) { seen = []; }
    var list = wrap.querySelector('[data-pdp-recently-viewed-list]');
    var limit = parseInt(wrap.dataset.limit, 10) || 6;
    var exclude = wrap.dataset.exclude || '';
    var keys = {};
    seen.forEach(function (item) {
      var key = item && (item.handle || (item.url || '').split('?')[0]);
      if (!item || !item.url || !item.title || !key || keys[key] || key === exclude || (item.url || '').indexOf('/products/' + exclude) > -1 || list.children.length >= limit) return;
      keys[key] = true;
      var li = document.createElement('li');
      var a = document.createElement('a'); a.href = item.url; a.className = 'product-recently-viewed__link';
      if (item.image) { var img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 120; img.height = 120; img.loading = 'lazy'; a.appendChild(img); }
      var t = document.createElement('span'); t.className = 'product-recently-viewed__title'; t.textContent = item.title; a.appendChild(t);
      if (item.price) { var pr = document.createElement('span'); pr.className = 'product-recently-viewed__price'; pr.textContent = item.price; a.appendChild(pr); }
      li.appendChild(a); list.appendChild(li);
    });
    if (list.children.length) wrap.hidden = false;
  }

  /* Sticky bar quantity mirrors the buy-box quantity (one source of truth: the form input) */
  var bar = document.querySelector('[data-sticky-atc]');
  var qtyIn = document.querySelector('.product__info-wrapper input[name="quantity"], .product-form__quantity input[name="quantity"]');
  var stickyQty = bar && bar.querySelector('[data-sticky-qty]');
  if (bar && qtyIn && stickyQty) {
    var syncQty = function () { if (document.activeElement !== stickyQty) stickyQty.value = qtyIn.value; };
    qtyIn.addEventListener('change', syncQty); qtyIn.addEventListener('input', syncQty); syncQty();
    stickyQty.addEventListener('change', function () {
      var v = Math.max(parseInt(stickyQty.value, 10) || 1, parseInt(qtyIn.min, 10) || 1);
      if (parseInt(qtyIn.max, 10)) v = Math.min(v, parseInt(qtyIn.max, 10));
      stickyQty.value = v; qtyIn.value = v; qtyIn.dispatchEvent(new Event('change', { bubbles: true }));
    });
    bar.querySelectorAll('[data-sticky-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(qtyIn.step, 10) || 1;
        var v = (parseInt(stickyQty.value, 10) || 1) + (b.dataset.stickyQtyStep === 'plus' ? step : -step);
        stickyQty.value = Math.max(v, parseInt(qtyIn.min, 10) || 1);
        stickyQty.dispatchEvent(new Event('change'));
      });
    });
  }

  /* Quote + back-in-stock: post by fetch and show the success copy in place (the native action is the no-JS
     fallback). Delegated: the delivery block is re-rendered on variant change, so no element-bound listeners. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ajax-contact]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    if (f.dataset.busy) return; /* in-flight guard: Enter + a second tap never double-post */
    f.dataset.busy = '1';
    var btn = f.querySelector('button[type="submit"]');
    var ok = f.querySelector('[data-ajax-success]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = btn.dataset.sending || btn.textContent; }
    fetch(f.action, { method: 'POST', body: new FormData(f), headers: { 'Accept': 'text/html' }, redirect: 'follow' })
      .then(function (r) {
        /* spam challenge or a validation re-render both answer 200: only a real contact_posted redirect counts */
        if (!r.ok || r.url.indexOf('/challenge') > -1 || r.url.indexOf('contact_posted=true') === -1) throw new Error('contact ' + r.status);
        if (ok) { ok.textContent = f.dataset.success || 'Thanks.'; ok.hidden = false; }
        f.querySelectorAll('input:not([type=hidden]), textarea, button[type=submit]').forEach(function (el) { el.hidden = true; });
        f.querySelectorAll('label').forEach(function (el) { el.hidden = true; });
        delete f.dataset.busy;
      })
      .catch(function () {
        /* fall back to the native post so the request is never lost */
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || btn.textContent; }
        delete f.dataset.busy;
        f.removeAttribute('data-ajax-contact');
        f.submit();
      });
  });
})();
